const LobeStylesheet = () => {
  return (
    <head>
      <link rel="stylesheet" href="/css/lobe.css" />
    </head>
  );
};

export default LobeStylesheet;
